import Promise from 'es6-promise'
/**
 * 通过插件或者和中间件js的交互，返回LODOP对象
 * @return {Object}
 */
export function getCLODOP(){
    const info={};
    /** @namespace options.forceCLODOP */
    try{
        /** @namespace window.getCLodop */
        let getCLodop=window.getCLodop||null;
        if(getCLodop){
            info.LODOP=getCLodop();
        }
    } catch(err) {

    }
    if (info.LODOP) {
        info.success=true;
    }
    return info
}
/**
 * 通过插件或者和中间件js的交互，返回LODOP对象
 * @return {Object}
 */
export function getLODOP(){
    const info={};
    let $object=document.getElementById("LODOP_PLUGIN_OBJECT"),$embed=document.getElementById("LODOP_PLUGIN_EMBED");
    if (!$object){
        let $Lodop=document.createElement('div');
        $Lodop.innerHTML='<object id="LODOP_PLUGIN_OBJECT" classid="clsid:2105C259-1E0C-4534-8141-A753534CB4CA" width="0" height="0" style="position: absolute;left: -100px;z-index: -9999"><embed id="LODOP_PLUGIN_EMBED" type="application/x-print-lodop" width="0" height="0"></embed></object>';
        document.body.appendChild($Lodop);
        $object=document.getElementById("LODOP_PLUGIN_OBJECT");
        $embed=document.getElementById("LODOP_PLUGIN_EMBED");
    }
    if((navigator.userAgent.indexOf('MSIE') >= 0) || (navigator.userAgent.indexOf('Trident') >= 0)){
        info.LODOP=$object;
    }else {
        info.LODOP=$embed
    }
    return new Promise(resolve=>{
        let interval=0;
        let max=5;
        let timer=(interval,number)=>{
            number++;
            if(number>max){
                resolve(info);
                timer=null;
            }else {
                setTimeout(()=>{
                    if (info.LODOP&&info.LODOP.VERSION) {
                        info.success=true;
                        resolve(info);
                        timer=null;
                    }else {
                        timer(200,number);
                    }
                },interval);
            }
        };
        timer(interval,0);
    })
}
